import { color } from '@stockbit/ui';
import styled from 'styled-components';

// copy from web legacy in build.css
const DiscoverPeopleWrapper = styled.div`
  max-width: 545px;

  .stream-avatar {
    width: 40px;
    height: 40px;
    border-radius: 40px;
    background: #a2a7b0;
    color: #fff;
    text-align: center;
    font-size: 20px;
    font-style: normal;
  }

  .boarding-list-wrap {
    height: 448px;
    overflow-y: scroll;
    margin-right: -15px;
    padding-right: 12px;
  }

  .boarding-in.people .boarding-list-wrap {
    height: 480px;
  }

  @media screen and (max-height: 800px) {
    .boarding-list-wrap {
      height: 390px;
    }
    .boarding-in.people .boarding-list-wrap {
      height: 420px;
    }
  }

  @media only screen and (max-width: 500px) {
    .boarding-list {
      width: calc(100vw - 40px);
    }

    .boarding-list-wrap {
      height: 280px;
      overflow-y: scroll;
    }
    .boarding-in.people .boarding-list-wrap {
      height: 300px;
    }

    .boarding-in.company .follow-bio {
      width: calc(100% - 80px);
      margin: 0;
    }
  }

  .boarding-search-wrap {
    position: relative;
  }

  .boarding-list {
    font-size: 14px;
  }

  .boarding-list-item {
    display: flex;
    align-item: center;
    padding: 5px 0;
  }

  .boarding-list-item > * {
    display: inline-block;
    vertical-align: middle;
  }

  .follow-bio {
    width: calc(100% - 185px);
    color: #6b6b6b;
    margin: 0 20px;
  }

  .follow-bio.no-avatar {
    width: calc(100% - 120px);
    margin: 0 20px 0 0;
  }

  .follow-bio a {
    color: #333333;
    font-weight: bold;
  }

  .follow-bio div {
    word-break: break-word;
  }

  .boarding-list-item .follow-bio-in {
    text-align: left;
    margin: 0;
  }

  .follow-bio-in .follow-bio-username {
    font-size: 16px;
    color: #333333;
  }

  .follow-bio-in .follow-bio-reason {
    font-size: 13.5px;
    color: #969696;
  }

  .boarding-list.stock-list .follow-bio {
    width: calc(100% - 140px);
  }

  .boarding-list .follow-bio-in > * {
    display: block;
    vertical-align: middle;
  }

  @media screen and (max-width: 720px) {
    .follow-bio {
      font-size: 13px;
      margin: 0 15px;
    }

    .follow-bio div {
      margin-top: 2px;
    }

    .stream-avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      margin: 0 auto;
      border-radius: 40px;
      background: #a2a7b0;
      color: #fff;
      text-align: center;
      font-size: 20px;
      font-style: normal;
    }

    .follow-following,
    .follow-follow {
      width: 80px;
    }
  }

  .boarding-in.company .follow-bio {
    width: calc(100% - 100px);
    margin: 0;
  }

  .stream-avatar i {
    font-style: normal;
    display: block;
    width: 50px;
    height: 50px;
    line-height: 50px;
    border-radius: 50px;
    background: #a2a7b0;
    color: #fff;
    text-align: center;
    font-size: 28px;
    overflow: hidden;
    text-transform: uppercase;
  }

  .stream-avatar img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .boarding-list-item .stream-avatar i {
    width: 40px;
    height: 40px;
    line-height: 33px;
    border-radius: 40px;
    font-size: 22px;
  }

  .stream-avatar i img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .follow-following {
    border: solid 1px #dadada;
    float: right;
    width: 100px;
    text-align: center;
    height: 30px;
    line-height: 26px;
    font-family: var(--font-bold);
    border-radius: 4px;
    cursor: pointer;
  }

  .follow-follow {
    border: solid 1px #dadada;
    float: right;
    width: 100px;
    text-align: center;
    height: 32px;
    line-height: 30px;
    font-family: var(--font-bold);
    border-radius: 5px;
    color: #dadada;
    cursor: pointer;
    font-weight: 700;
  }

  .follow-follow {
    border: solid 1px ${color.primary};
    color: ${color.primary};
  }

  .popavatar {
    width: 100%;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    -webkit-animation-name: popimg;
    animation-name: popimg;
  }

  .search-main-close {
    font-size: 12px;
    cursor: pointer;
    font-style: italic;
  }

  .search-main-close:hover {
    color: #6b6b6b;
  }

  .option.people b {
    max-width: calc(100% - 76px);
    margin-right: 10px;
  }

  .or-send-to .option.people b {
    width: auto;
    max-width: calc(100% - 82px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .or-send-to .option.people em[class^='icon-'] {
    position: static;
    font-size: 14px;
  }
`;

const IconAvatarInvalid = styled.i`
  width: 25px;
  height: 25px;
  line-height: 28px;
  border-radius: 30px;
  font-size: 12px;
  background: #a2a7b0;
  color: #fff;
  padding-right: 2px;
  text-align: center;
  text-transform: uppercase;
`;

export default { DiscoverPeopleWrapper, IconAvatarInvalid };
